import { SelectProps, Select } from 'antd'
import { useMemo } from 'react'

import { useStocksServiceGetPrescriptionListEndpoint } from 'src/api/queries'

export const PrescriptionsSelect = (props: SelectProps) => {
  const { data, isLoading } = useStocksServiceGetPrescriptionListEndpoint()

  const options = useMemo(
    () => data?.data?.map((item) => ({ value: item.id, label: item.name })),
    [data]
  )

  return (
    <Select
      allowClear
      popupMatchSelectWidth={true}
      options={options}
      loading={isLoading}
      {...props}
    />
  )
}
